import {
  isCardsLayout,
  useResponsiveLayout,
} from 'hooks/layout/useResponsiveLayout';
import { useSelector } from 'react-redux';
import * as MyOrderIntentionsEditSelector from 'store/state/myOrderIntentionEdit/myOrderIntentionEditSelectors';
import AddBuyIntentionTable from '../List/AddBuyIntentionTable';
import EditIntentionItems from '../List/Cards/EditIntentionItems';

export default function Step02Resume() {
  const tableData = useSelector(MyOrderIntentionsEditSelector.getOverviewEdit);
  const isCards = isCardsLayout(useResponsiveLayout());

  if (isCards) return <EditIntentionItems tableData={tableData} />;

  return (
    <div key="1">
      <AddBuyIntentionTable tableData={tableData} />
    </div>
  );
}
